import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomCheckoutService } from '@checkout/feature';
import { CustomOrder, PaymentStatus } from '@order/const';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-body',
  templateUrl: './order-confirmation-info-body.component.html',
  styleUrls: ['./order-confirmation-info-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorOrderConfirmationInfoBodyComponent implements OnInit {
  order$: Observable<CustomOrder>;
  protected readonly PaymentStatus = PaymentStatus;

  constructor(private customCheckoutService: CustomCheckoutService) {}

  ngOnInit(): void {
    this.order$ = this.customCheckoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));
  }
}
